
const SlideScene = require('./SlideScene')
/**
 * 代表幻燈片的某一章節
 */
class SlideContent{
  /**
   * @param {SlideContent} opts
   */
  constructor(opts = {}){
    /**
     * @type {?string}
     */
    this.title = opts.title || null
    this.keywords = opts.keywords || []
    /**
     * auto: 自動輪播
     * manual: 手動切換下一頁
     * @type {String}
     */
    this.mode = opts.mode || 'auto'
    /**
     * 自動切換的時間 (如果還沒唸完會等待唸完)
     * @type {Number}
     */
    this.switchInterval = opts.switchInterval || 2000
    /**
     * 章節的子頁面
     * @type {SlideScene[]}
     */
    this.scenes = opts.scenes || []
    this.scenes = this.scenes.map((scene)=>{
      return new SlideScene(scene)
    })
  }
}
module.exports = SlideContent
